//偏好志愿
//报考批次
import React,{useState} from 'react';
import { Cascader } from 'antd';
import styles from './customCascader.module.scss';
import setRequiredFields from './GaokaoxkStore'
import { SVGPureIcon } from "@/ui";
import { observer } from 'mobx-react-lite';

//报考类别
const options = [
    {
        value: '专业优先',
        label: '专业优先',
    },
    {
        value: '院校优先',
        label: '院校优先',
    },
];

const Volunteer = () => {
  const [dropdownVisible, setDropdownVisible] = useState(false); 
    const onChange = value => {
        setRequiredFields.setRequiredFields({
            volunteer: value[0],  // 更新 classification 属性
        });
        setRequiredFields.setOptionalFields({
            volunteer: value
        });

    };
    const handleDropdownVisibleChange = (visible) => {    
      setDropdownVisible(visible);
    };
    return (
        <Cascader
            className={styles['custom-cascader']}
            popupClassName={styles['custom-cascader-dropdown']}
            style={{ 
                width: 'auto', // 关键：设置为 auto
                minWidth: 106, // 保留最小宽度
                display: 'inline-block', // 确保宽度自适应
                height:'38px'
              }}
            onDropdownVisibleChange={handleDropdownVisibleChange}
            allowClear={false}
            placeholder="志愿偏好"
            value={setRequiredFields.optionalFields.volunteer}
            options={options}
            onChange={onChange}
             // 自定义选择器右侧的下拉箭头
                  suffixIcon={
                    <SVGPureIcon
                    name={dropdownVisible?"shangjant":"ArrowDown"}
                      className=''
                      style={{ width: 16, height: 16 }}
                    />
                  }
            
                  // 自定义下拉菜单中的展开箭头
                  expandIcon={
                    (
                      <SVGPureIcon
                        name="ArrowRight"
                        className='text-black text-opacity-50'
                        style={{
                          width: 16,
                          height: 16,
                        }}
                      />
                    )
                  }
        />
    )
}
export default observer(Volunteer);